import { Card, Space } from 'antd'
import styled from 'styled-components'
import { mediaBreakpointDown } from 'styles/minxins'

export const StyledSpace = styled(Space)``

export const StyledCard = styled(Card)`
  width: 260px;
  height: 92px;
  margin-top: 16px;
  border-radius: 12px;
  position: relative;
  .ant-card-body {
    padding: 16px;
    height: 100%;
    cursor: pointer;
    .ant-card-meta-description {
      font-size: 1.1rem;
    }
    .ant-card-meta-detail > div:not(:last-child) {
      margin-bottom: 0;
    }
    .ant-card-meta {
      height: 100%;
    }
    .ant-card-meta-avatar {
      display: flex;
      align-items: center;
    }
  }
  .ant-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ${mediaBreakpointDown({
    breakpoint: 'lg',
    content: `
      width: 250px;
    `
  })}
  ${mediaBreakpointDown({
    breakpoint: 'md',
    content: `
      width: 240px;
    `
  })}
`
export const StyledSpanCount = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 1.4rem;
  font-weight: 700;
  color: inherit;
`
